import { makeStyles, SkeletonItem, tokens } from '@fluentui/react-components';
import React from 'react';

import { Flex } from '@tdp/common/fluentV9MigrationComponents';

const useStyle = makeStyles({
  title: { height: '24px', maxWidth: '50%' },
  subTitle: { height: '16px', maxWidth: '40%' },
  heading: { margin: '32px 40px', maxWidth: '10%' },
  heroWrapper: { margin: '32px 40px' },
  hero: { height: '240px', maxWidth: '25%' },
  cardWrapper: { margin: '0px 50px' },
  card: { height: '100px', maxWidth: '50%' },
});

export const HomePageShimmer: React.FC = () => {
  const shimmerStyles = useStyle();
  return (
    <Flex
      fill
      column
      gap="gap.medium"
      aria-label="loading"
    >
      <Flex column style={{ margin: '60px 0px 20px 40px' }} gap="gap.small">
        <SkeletonItem className={shimmerStyles.title} />
        <SkeletonItem className={shimmerStyles.subTitle} />
      </Flex>
      <Flex className={shimmerStyles.heroWrapper} gap="gap.large">
        <SkeletonItem className={shimmerStyles.hero} />
        <SkeletonItem className={shimmerStyles.hero} />
        <SkeletonItem className={shimmerStyles.hero} />
        <SkeletonItem className={shimmerStyles.hero} />
      </Flex>
      <Flex gap="gap.large">
        <SkeletonItem className={shimmerStyles.heading} />
      </Flex>
      <Flex className={shimmerStyles.cardWrapper} gap="gap.large">
        <SkeletonItem className={shimmerStyles.card} />
        <SkeletonItem className={shimmerStyles.card} />
      </Flex>
      <Flex className={shimmerStyles.cardWrapper} gap="gap.large">
        <SkeletonItem className={shimmerStyles.card} />
        <SkeletonItem className={shimmerStyles.card} />
      </Flex>
      <Flex className={shimmerStyles.cardWrapper} gap="gap.large">
        <SkeletonItem className={shimmerStyles.card} />
        <SkeletonItem className={shimmerStyles.card} />
      </Flex>
    </Flex>
  );
};
